import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/header/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Policy/Policy.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/Cookie/PoliticsModule.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/modules/PoliticsModule/Card/Card.tsx");
